var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"small"},[_c('moto-small-size',{staticClass:"my-5"}),_c('short-description-small-size'),_c('how-does-it-work-small-size'),_c('partners-small-size')],1)}
var staticRenderFns = []

export { render, staticRenderFns }